import { cn } from '@/lib/utils';

type AnswerValue =
  | { kind: 'choice'; choice_id: number }
  | { kind: 'multi'; choice_ids: number[] }
  | { kind: 'written'; text: string };

export type { AnswerValue };

export function QuestionCard({
  question,
  answer,
  onSelectSingle,
  onToggleMulti,
  onSetWritten,
}: {
  question: {
    id: number;
    content: string;
    question_type: string;
    choices: { id: number; content: string; sort_order: number }[];
  };
  answer: AnswerValue | undefined;
  onSelectSingle: (choiceId: number) => void;
  onToggleMulti: (choiceId: number) => void;
  onSetWritten: (text: string) => void;
}) {
  const sorted = [...question.choices].sort((a, b) => a.sort_order - b.sort_order);

  return (
    <div className="rounded-xl border border-border bg-card p-6">
      <h2 className="text-lg font-semibold text-card-foreground">{question.content}</h2>
      <div className="mt-5 space-y-3">
        {question.question_type === 'written' ? (
          <textarea
            value={answer?.kind === 'written' ? answer.text : ''}
            onChange={(e) => onSetWritten(e.target.value)}
            placeholder="Escribe tu respuesta aquí..."
            rows={5}
            className="w-full rounded-lg border border-border bg-background px-4 py-3 text-sm text-foreground placeholder:text-muted-foreground focus:border-primary focus:outline-none focus:ring-1 focus:ring-primary"
          />
        ) : question.question_type === 'multiple_select' ? (
          sorted.map((c) => {
            const chk = answer?.kind === 'multi' && answer.choice_ids.includes(c.id);
            return (
              <button
                key={c.id}
                type="button"
                onClick={() => onToggleMulti(c.id)}
                className={cn(
                  'flex w-full items-center gap-3 rounded-lg border px-4 py-3 text-left text-sm transition-colors',
                  chk
                    ? 'border-primary bg-primary/10 font-medium text-primary'
                    : 'border-border bg-background text-foreground hover:border-primary/50 hover:bg-accent/50',
                )}
              >
                <span
                  className={cn(
                    'flex h-5 w-5 shrink-0 items-center justify-center rounded border text-xs',
                    chk
                      ? 'border-primary bg-primary text-primary-foreground'
                      : 'border-muted-foreground/40',
                  )}
                >
                  {chk && '✓'}
                </span>
                {c.content}
              </button>
            );
          })
        ) : (
          sorted.map((c) => {
            const sel = answer?.kind === 'choice' && answer.choice_id === c.id;
            return (
              <button
                key={c.id}
                type="button"
                onClick={() => onSelectSingle(c.id)}
                className={cn(
                  'w-full rounded-lg border px-4 py-3 text-left text-sm transition-colors',
                  sel
                    ? 'border-primary bg-primary/10 font-medium text-primary'
                    : 'border-border bg-background text-foreground hover:border-primary/50 hover:bg-accent/50',
                )}
              >
                {c.content}
              </button>
            );
          })
        )}
      </div>
    </div>
  );
}
